import { useState } from 'react';

interface StarRatingProps {
  value: number;
  onChange?: (rating: number) => void;
  readonly?: boolean;
  size?: 'sm' | 'md' | 'lg';
}

const SIZE_MAP = {
  sm: { icon: 'text-sm', gap: 'gap-0.5', btn: 'w-5 h-5' },
  md: { icon: 'text-xl', gap: 'gap-1', btn: 'w-7 h-7' },
  lg: { icon: 'text-2xl', gap: 'gap-1.5', btn: 'w-8 h-8' },
};

export default function StarRating({
  value,
  onChange,
  readonly = false,
  size = 'md',
}: StarRatingProps) {
  const [hovered, setHovered] = useState(0);
  const { icon, gap, btn } = SIZE_MAP[size];
  const active = hovered || value;

  return (
    <div className={`flex items-center ${gap}`}>
      {[1, 2, 3, 4, 5].map((star) => {
        const filled = active >= star;
        return (
          <button
            key={star}
            type="button"
            disabled={readonly}
            aria-label={`Rate ${star} star${star > 1 ? 's' : ''}`}
            onClick={() => !readonly && onChange?.(star)}
            onMouseEnter={() => !readonly && setHovered(star)}
            onMouseLeave={() => !readonly && setHovered(0)}
            className={`${btn} flex items-center justify-center transition-transform duration-100 ${
              readonly ? 'cursor-default' : 'cursor-pointer hover:scale-125'
            }`}
          >
            <i
              className={`${filled ? 'ri-star-fill' : 'ri-star-line'} ${
                filled ? 'text-amber-400' : 'text-amber-300/30'
              } ${icon}`}
            />
          </button>
        );
      })}
    </div>
  );
}
